import { cloneElement, Children, Component } from 'react';

import cx from 'classnames';

import styles from '../../../styles/accordian.scss';

interface Props {
  selected?: string;
  showRadio?: boolean;
  noCollapseAll?: boolean;
  type?: string;
  className?: string;
}

interface State {
  selected: string;
}

export class Accordion extends Component<Props, State> {
  constructor(args: Props) {
    super(args);

    this.state = {
      selected: this.props.selected,
    };
  }

  public enhanceSection = (child: any) => {
    const selectedId = this.state.selected;
    const id = child.props.id;

    return cloneElement(child, {
      key: id,
      styles,
      _selected: id === selectedId,
      _onSelect: this.onSelect,
      _showRadio: this.props.showRadio,
    });
  };

  public onSelect = (id: string) => {
    // trackAction(this.props.userInfo, `${this.props.source}-faq-selected`, `${id}`);
    if (this.state.selected !== id) {
      this.setState({
        selected: id,
      });
    } else {
      if (this.props.noCollapseAll) {
        return;
      }
      this.setState({
        selected: null,
      });
    }
  };

  public render() {
    const children = Children.map(this.props.children, this.enhanceSection);
    return (
      <div
        className={cx(styles.accordion, styles.custom, this.props.className)}
      >
        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/ui/accordian/accordian.tsx